import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { View } from '@smarterservices/smarter-ui';

/**
 * Plain layout component without header or footer
 * 
 * @component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to render within the layout
 * @returns {React.ReactElement} Layout with content area only
 */
const PlainLayout = ({ children }) => {
  useEffect(() => {
    // Ensure no footer class is present
    document.body.classList.remove('has-footer');
    
    return () => {
      // Clean up
      document.body.classList.remove('has-footer');
    };
  }, []);

  return (
    <View as="div" className="main-content no-footer" background="secondary">
      {children}
    </View>
  );
};

PlainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PlainLayout;